
<template>
    <div>
        <a-page-header style="border: 1px solid rgb(235, 237, 240)" :ghost="false" title="Pembobotan">
            <common-training-header/>
        </a-page-header>

        <!-- <a-row type="flex" style="margin-bottom: 12px">
            <a-col  style="padding-left: 12px" flex="1 1 200px"></a-col>
            <a-col flex="0 1 300px"><a-button type="primary" icon="plus" block @click="showModal('')"> Tambah Pembobotan</a-button></a-col>
        </a-row> -->

        <a-card type="inner" size="small">
            <a-descriptions size="small" style="margin-bottom: 20px" bordered>
                <a-descriptions-item v-for="item in this.items.aspects" :key="item.id" :label="item.name">
                    {{ (item.weight*100) }}
                    <a-tooltip title="Edit Bobot">
                            <a-button
                                style="margin-left: 14px"
                                size="small"
                                type="primary"
                                icon="edit"
                                @click="showModal(item.id, (item.weight*100), item.name, true)"
                            />
                        </a-tooltip>
                </a-descriptions-item>
            </a-descriptions>

            <a-table
                class="pcp-table"
                :dataSource="items.resume_objectives"
                rowKey="id"
                :pagination="{
                    current: items.current_page,
                    total: items.total,
                    defaultPageSize: items.per_page
                }"
                :loading="loading"
                @change="tableChanged"
                bordered>

                <a-table-column key="parameter" title="Parameter" className="align-center text-small text-left">
                    <template slot-scope="record">
                        {{ record.objective }}
                    </template>
                </a-table-column> 

                <a-table-column key="portion" title="Bobot" className="align-center text-small text-center">
                    <template slot-scope="record">
                        {{ (record.config.weight*100) }}
                    </template>
                </a-table-column>

                <a-table-column key="action" title="Action" className="align-center text-small text-center">
                    <template slot-scope="record">
                        <a-tooltip title="Edit Pembobotan">
                            <a-button
                                size="small"
                                type="primary"
                                icon="edit"
                                @click="showModal(record.hash, (record.config.weight*100), record.objective, false)"
                            />
                        </a-tooltip>
                    </template>
                </a-table-column>
            </a-table>

            <a-modal
                :destroyOnClose="true"
                :footer="null"
                :visible="visible"
                :closable="false"
            >
                <classical-weighting-form
                    :id="id"
                    :weight="weight"
                    :isAspect="isAspect"
                    :parameter="parameter"
                    @handleClose="closeModal"
                />
            </a-modal>

        </a-card>
    </div>
</template>

<script>

export default {
    props: {
        training: {
            type: Object
        }
    },
    data() {
        return {
            form: this.$form.createForm(this),
            loading: false,
            expand: false,
            visible: false,
            isAspect: false,
            id: "",
            weight: "",
            parameter: "",
            processing: false,
            is_parent: false,
            items: {},
            filters: {
                q: null,
                page: 1
            }
        };
    },
    created() {
        this.items = this.getDefaultPagination();
        this.filters = _.merge(this.filters, this.$laravel.request);
        this.getItems();
    },
    methods: {
        handleSubmit(e) {
            e.preventDefault();
            this.pushState(this.filters);
            this.getItems();
        },
        handleReset(e) {
            e.preventDefault();
            this.filters = {
                q: null,
                page: 1
            };
        },
        tableChanged(pagination) {
            this.filters.page = pagination.current;
            this.pushState(this.filters);
            this.getItems();
        },
        getItems() {
            this.loading = true;
            this.$http
                .get(this.routeUri("api.classical.weighting"), {
                    params: this.filters
                })
                .then(response => (this.items = response.data))
                .catch(error => this.handleXhrError(error))
                .finally(() => (this.loading = false));
        },
        showModal(hash, weight, parameter, isAspect) {
            this.id = hash;
            this.weight = weight;
            this.parameter = parameter;
            this.isAspect = isAspect
            this.visible = true;
        },
        closeModal(isRefresh) {
            this.visible = false;

            if (isRefresh == true) {
                this.getItems();
            }
        }
    },
};
</script>
